import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const user = sessionStorage.getItem('currentUser');
    if (user) {
      // If user is already logged in, redirect to /home
      this.router.navigateByUrl('/home', { replaceUrl: true });
      return false;
    }
    return true; // Allow access to login page if not logged in
  }
}
